import React, {useState} from 'react'
import Plane from './Plane'
import Walls from './Walls'
import img1 from '../Assets/micro 1.png'

const Space2 = ({wallData}) => {


    return (
        <>
            <Plane  sceneImg={img1} sceneSize={[230.44, 123.9136]}/>
            <Walls  wallData={wallData}/>
        </>
    )
}

export default Space2
